import React from 'react';

import './Icon.css';

export const GameTypeUnlimited = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <circle cx="16" cy="16" r="15" stroke="#000" fill="#fff"/>
    </svg>
  );
});

export const GameTypeNormal = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <defs>
        <mask id="gt-upperRightCorner">
          <path fill="#fff" d="M16 0h16v16H16z"/>
        </mask>
      </defs>
      <circle cx="16" cy="16" r="15" fill="#fff"/>
      <circle cx="16" cy="16" r="15" fill="#900" mask="url(#gt-upperRightCorner)"/>
      <circle cx="16" cy="16" r="15" stroke="#000" fill="none"/>
    </svg>
  );
});

export const GameTypeFast = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <defs>
        <mask id="gt-rightSide">
          <path fill="#fff" d="M16 0h16v32H16z"/>
        </mask>
      </defs>
      <circle cx="16" cy="16" r="15" fill="#fff"/>
      <circle cx="16" cy="16" r="15" fill="#900" mask="url(#gt-rightSide)"/>
      <circle cx="16" cy="16" r="15" stroke="#000" fill="none"/>
    </svg>
  );
});

export const GameTypeStress = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <defs>
        <mask id="gt-invert-upperLeftCorner">
          <path fill="#fff" d="M16 0h16v32H16zM0 16h16v16H0z"/>
        </mask>
      </defs>
      <circle cx="16" cy="16" r="15" fill="#fff" />
      <circle cx="16" cy="16" r="15" fill="#900" mask="url(#gt-invert-upperLeftCorner)" />
      <circle cx="16" cy="16" r="15" stroke="#000" fill="none" />
    </svg>
  );
});

export const GameTypeRush = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <circle cx="16" cy="16" r="15" stroke="#000" fill="#900"/>
    </svg>
  );
});

export const GameTypePanic = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <circle cx="16" cy="16" r="15" stroke="#000" fill="#f00"/>
    </svg>
  );
});

export const BoardTypeClassic = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <path stroke="#000" fill="#B9CBDF" d="M0 0h32v32H0z"/>
      <text x="16" y="23" textAnchor="middle">S</text>
    </svg>
  );
});

export const BoardTypeRandom = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <path stroke="#000" fill="#B9CBDF" d="M0 0h32v32H0z"/>
      <path d="M6 8h4v4H6zM14 10h4v4h-4zM22 10h4v4h-4zM10 16h4v4h-4zM6 22h4v4H6zM24 20h4v4h-4z"/>
    </svg>
  );
});

export const BoardTypeSpecial = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <path stroke="#000" fill="#B9CBDF" d="M0 0h32v32H0z"/>
      <text x="16" y="23" textAnchor="middle">2</text>
    </svg>
  );
});

export const Ranked = React.memo((props) => {
  const fillColor = props.ranked ? '#F3E10C' : '#fff';
  return (
    <svg viewBox="0 0 32 32" className="icon">
      <path d="M15.99997358 2.00073l5.12239518 8.06474902 8.87812887 2.62956498-5.71162686 7.61527989.3644748 9.68998216L16.001181 26.64173l-8.65183541 3.35942395.36352519-9.69001784L2.00049763 12.696416l8.87787113-2.63043502z" fill={fillColor} stroke="#000"></path>
    </svg>
  );
});
